// AppError.ts
import { ErrorDetails } from '../../services/api.models';

export class AppError extends Error {
  errorStatus?: number | string;
  errorText?: string;

  constructor({ errorStatus, errorText }: ErrorDetails) {
    super(errorText || 'Unknown error');
    this.name = 'AppError';
    this.errorStatus = errorStatus;
    this.errorText = errorText || 'Unknown error';
    // For TypeScript + transpilation compatibility
    Object.setPrototypeOf(this, AppError.prototype);
  }
}
